import React, { useEffect, useState } from 'react';
import Translation from './Translation';
import { ZdsIcon } from '@zig-design-system/ui-components-react';
import ShareThisPageConfigurationService from '../services/ShareThisPageConfigurationService';
const ShareThisPage = ({ title }) => {
    const pageUrl = encodeURIComponent(window.location.href);
    const pageTitle = encodeURIComponent(title || document.title);
    const [configuration, setConfiguration] = useState(null);
    useEffect(() => {
        if (!configuration) {
            ShareThisPageConfigurationService.get().then(setConfiguration);
        }
    });
    const print = () => {
        window.print();
    };
    if (!configuration) {
        return null;
    }
    const via = configuration.via ? encodeURIComponent(configuration.via) : null;
    const platforms = configuration.platforms.map((platform) => {
        return Object.assign(Object.assign({}, platform), { url: platform.path + createQueryStringForPlatform(platform.key, pageTitle, pageUrl, via) });
    });
    if (platforms.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("h6", { className: "social-networks__header zds-headline-xs zds-margin-bottom-4" },
            React.createElement(Translation, { item: "share_header" })),
        React.createElement("ul", { className: "zds-padding-0 zds-margin-y-3 zds-color-secondary" }, platforms.map((platform, index) => (React.createElement("li", { className: `social-networks__item zds-inline-block ${index < platforms.length - 1 ? 'zds-margin-right-4' : ''}`, key: platform.key },
            React.createElement("a", Object.assign({ className: "social-networks__link zds-block", target: platform.target }, (platform.key === 'print' ? { onClick: print } : { href: platform.url })),
                platform.key === 'mail' && (React.createElement(ZdsIcon, { className: "social-networks__icon", library: "fa-solid", name: "square-envelope", title: platform.key })),
                platform.key === 'print' && (React.createElement(ZdsIcon, { className: "social-networks__icon", library: "fa-solid", name: "print", title: platform.key })),
                platform.key !== 'mail' && platform.key !== 'print' && (React.createElement(ZdsIcon, { className: "social-networks__icon", library: "fa-brands", name: platform.icon, title: platform.key })))))))));
};
const createQueryStringForPlatform = (platformKey, pageTitle, pageUrl, via = null) => {
    switch (platformKey) {
        case 'facebook':
            return `?u=${pageUrl}&t=${pageTitle}`;
        case 'twitter':
            return `?url=${pageUrl}&text=${pageTitle}` + (via ? `&via=${via}` : '');
        case 'linkedin':
            return `?mini=true&url=${pageUrl}&title=${pageTitle}`;
        case 'whatsapp':
            return `?text=${pageTitle} ${pageUrl}`;
        case 'mail':
            return `?subject=${pageTitle}&body=${pageUrl}`;
        default:
            return '';
    }
};
export default ShareThisPage;
